import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import API_BASE_URL from "../../../helper.js";

// Function to show success modal
function showSuccessModal(message) {
    $("#successMessage").text(message);
    const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
    modal.show();
}

// ✅ MOVE FUNCTION OUTSIDE (ONLY CHANGE)
function loadAllProduct() {
    $.ajax({
        url: `${API_BASE_URL}/api/product/all`,
        type: "GET",
        success: function (products) {

            products.reverse();
            let rows = "";

            products.forEach((product, index) => {
                rows += `
                    <tr>
                        <td>${index + 1}</td>
                        <td><img src="${API_BASE_URL}/assets/Images/${product.image}" width="80" height="80" /></td>
                        <td>${product.name}</td>
                        <td>${product.description}</td>
                        <td>
                            <button class="btn btn-primary btn-sm editProductBtn" data-id="${product.id}">Edit</button>
                            <button class="btn btn-danger btn-sm mx-1 deletePrductBtn" data-id="${product.id}">Delete</button>
                        </td>
                    </tr>
                `;
            });

            $("#allProductData").html(rows);
        },
        error: function () {
            alert("Failed to load products!");
        }
    });
}

// ✅ KEEP THIS SAME
window.loadProducts = function () {
    loadAllProduct();
};

$(document).ready(function () {

    // Add Product
    $("#addProductForm").submit(function (e) {
        e.preventDefault();

        const formData = new FormData();
        formData.append("name", $("#name").val());
        formData.append("description", $("#discription").val());
        formData.append("image", $("#image")[0].files[0]);

        $.ajax({
            url: `${API_BASE_URL}/api/product/add`,
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,

            success: function () {

                showSuccessModal("Product Added Successfully!");

                $("#addProductForm")[0].reset();

                // Close Product Modal
                const productModal = window.bootstrap.Modal.getInstance(document.getElementById("productModal"));
                productModal.hide();
                loadAllProduct();

            },

            error: function (xhr) {
                console.log(xhr);
                alert("Failed to add [Product]!");
            }
        });
    });

    // OPEN EDIT MODAL
    $(document).on("click", ".editProductBtn", function () {
        const id = $(this).data("id");

        $.ajax({
            url: `${API_BASE_URL}/api/product/get/${id}`,
            type: "GET",
            success: function (b) {

                $("#editId").val(b.id);
                $("#editName").val(b.name);
                $("#editDescription").val(b.description);

                new window.bootstrap.Modal(document.getElementById("editProductModal")).show();
            },
            error: () => alert("Failed to fetch product data")
        });
    });

    // UPDATE Product
    $("#editProductForm").submit(function (e) {
        e.preventDefault();

        const id = $("#editId").val();
        const formData = new FormData();

        formData.append("name", $("#editName").val());
        formData.append("description", $("#editDescription").val());

        if ($("#editImage")[0].files.length > 0) {
            formData.append("image", $("#editImage")[0].files[0]);
        }

        $.ajax({
            url: `${API_BASE_URL}/api/product/update/${id}`,
            type: "POST",
            contentType: false,
            processData: false,
            data: formData,
            success: function () {
                showSuccessModal("Product Updated Successfully!");
                loadAllProduct();
                window.bootstrap.Modal.getInstance(document.getElementById("editProductModal")).hide();
            },
            error: () => alert("Failed to update Product")
        });
    });
    
    // Delete Product
    $(document).on("click", ".deletePrductBtn", function () {
        let id = $(this).data("id");

        if (!window.confirm("Are you sure you want to delete this product?")) {
            return;
        }

        $.ajax({
            url: `${API_BASE_URL}/api/product/delete/${id}`,
            type: "DELETE",
            success: function () {
                showSuccessModal("Product Delete Successfully!");
                loadAllProduct();
            },
            error: function (xhr) {
                console.error(xhr);
                alert("Failed to delete product!");
            }
        });
    });
});

// import $ from "jquery";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import API_BASE_URL from "../../../helper.js";

// // Function to show success modal
// function showSuccessModal(message) {
//     $("#successMessage").text(message);
//     const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
//     modal.show();
// }

// window.loadProducts = function () {
//     loadAllProduct();
// };

// $(document).ready(function () {

//     // Add Product
//     $("#addProductForm").submit(function (e) {
//         e.preventDefault();

//         const formData = new FormData();
//         formData.append("name", $("#name").val());
//         formData.append("description", $("#discription").val());
//         formData.append("image", $("#image")[0].files[0]);

//         $.ajax({
//             url: `${API_BASE_URL}/api/product/add`,
//             type: "POST",
//             data: formData,
//             contentType: false,
//             processData: false,

//             success: function () {

//                 showSuccessModal("Product Added Successfully!");

//                 $("#addProductForm")[0].reset();

//                 // Close Product Modal
//                 const productModal = window.bootstrap.Modal.getInstance(document.getElementById("productModal"));
//                 productModal.hide();
//                 loadAllProduct();

//             },

//             error: function (xhr) {
//                 console.log(xhr);
//                 alert("Failed to add [Product]!");
//             }
//         });
//     });

//     // ➤ Load All Products
//     function loadAllProduct() {
//         $.ajax({
//             url: `${API_BASE_URL}/api/product/all`,
//             type: "GET",
//             success: function (products) {

//                 products.reverse();
//                 let rows = "";

//                 products.forEach((product, index) => {
//                     rows += `
//                         <tr>
//                             <td>${index + 1}</td>
//                             <td><img src="${API_BASE_URL}/assets/Images/${product.image}" width="80" height="80" /></td>
//                             <td>${product.name}</td>
//                             <td>${product.description}</td>
//                             <td>
//                                 <button class="btn btn-primary btn-sm editProductBtn" data-id="${product.id}">Edit</button>
//                                 <button class="btn btn-danger btn-sm mx-1 deletePrductBtn" data-id="${product.id}">Delete</button>
//                             </td>
//                         </tr>
//                     `;
//                 });

//                 $("#allProductData").html(rows);
//             },
//             error: function () {
//                 alert("Failed to load products!");
//             }
//         });
//     }


//     // OPEN EDIT MODAL
//     $(document).on("click", ".editProductBtn", function () {
//         const id = $(this).data("id");

//         $.ajax({
//             url: `${API_BASE_URL}/api/product/get/${id}`,
//             type: "GET",
//             success: function (b) {

//                 $("#editId").val(b.id);
//                 $("#editName").val(b.name);
//                 $("#editDescription").val(b.description);

//                 new window.bootstrap.Modal(document.getElementById("editProductModal")).show();
//             },
//             error: () => alert("Failed to fetch product data")
//         });
//     });

//     // UPDATE Product
//     $("#editProductForm").submit(function (e) {
//         e.preventDefault();

//         const id = $("#editId").val();
//         const formData = new FormData();

//         formData.append("name", $("#editName").val());
//         formData.append("description", $("#editDescription").val());

//         if ($("#editImage")[0].files.length > 0) {
//             formData.append("image", $("#editImage")[0].files[0]);
//         }

//         $.ajax({
//             url: `${API_BASE_URL}/api/product/update/${id}`,
//             type: "POST",
//             contentType: false,
//             processData: false,
//             data: formData,
//             success: function () {
//                 showSuccessModal("Product Updated Successfully!");
//                 loadAllProduct();
//                 window.bootstrap.Modal.getInstance(document.getElementById("editProductModal")).hide();
//             },
//             error: () => alert("Failed to update Product")
//         });
//     });
    
//     // Delete Product
//     $(document).on("click", ".deletePrductBtn", function () {
//         let id = $(this).data("id");

//         if (!window.confirm("Are you sure you want to delete this product?")) {
//             return;
//         }

//         $.ajax({
//             url: `${API_BASE_URL}/api/product/delete/${id}`,
//             type: "DELETE",
//             success: function () {
//                 showSuccessModal("Product Delete Successfully!");
//                 loadAllProduct();
//             },
//             error: function (xhr) {
//                 console.error(xhr);
//                 alert("Failed to delete product!");
//             }
//         });
//     });
// });


